export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex flex-col justify-end pb-20 md:pb-28 overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9fc4f1622ccfc60f27cd21bb02f55a7c.jpg"
          alt="INTEROSMO P.C. iOS Development"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/55 to-black/65"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          {/* Left: Main Title */}
          <div className="max-w-2xl">
            <p className="text-white/60 text-xs font-medium tracking-[0.25em] uppercase mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              iOS App Development Studio
            </p>
            <h1 className="text-white" style={{ fontFamily: "'DM Serif Display', serif" }}>
              <span className="block text-5xl md:text-7xl leading-[1.08] font-normal">
                Crafting Apps
              </span>
              <span className="block text-5xl md:text-7xl leading-[1.08] font-normal italic">
                That Protect &amp;
              </span>
              <span className="block text-5xl md:text-7xl leading-[1.08] font-normal">
                Perform.
              </span>
            </h1>
          </div>

          {/* Right: Description */}
          <div className="max-w-sm lg:mb-3">
            <p className="text-white/75 text-base leading-8" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
              INTEROSMO P.C. is a dedicated team of iOS development experts building applications that elevate mobile security and deliver outstanding user experiences across every device.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <div className="h-px w-10 bg-white/40"></div>
              <span className="text-white/40 text-xs tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
                Athens, Greece
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10">
        <span className="text-white/30 text-xs tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>Scroll</span>
        <div className="w-px h-8 bg-white/20"></div>
      </div>
    </section>
  );
}
